/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('cart:updated', function(event) {
  var cart = event.detail.cart; // Get the updated content of the cart
  // var hasJacket = false;
  // var hasPant = false;
  // var hasPromo = false;
  // for (item of cart.items) {
  //   if (item.title.includes('xJacket 4.0'))
  //     hasJacket = true;
  //   else if (item.title.includes('xPant 4.0'))
  //     hasPant = true;
  //   else if (item.title.includes('xTie'))
  //     hasPromo = true;
  // }
  // const show = hasJacket && hasPant && !hasPromo;
  // document.getElementById('xtee-popup').classList.toggle('show', show);
});

$(document).on('click', '.popup__overlay', function() {
  document.getElementById('xtee-popup').classList.toggle('show', false);
});

$(document).on('change', 'select[filter-images]', function() {
  if ($(this).attr('aria-label') == 'Color' || $(this).attr('aria-label') == 'Coloris') {
    const id = $(this).attr('filter-images');
    const images = $('#' + id);
    images.find('img').hide();
    images.find(`[data-color="${$(this).val()}"]`).show();
  }
});

$(document).on('click', 'combo-box .combo-box__option-item', function() {
  const combo = $(this).closest('combo-box');
  const select = combo.find('select[filter-images]');
  const label = select.attr('aria-label');
  if (label !== 'Color' && label !== 'Coloris') return;
  const id = select.attr('filter-images');
  const images = $('#' + id);
  const value = $(this).attr('value');
  images.find('img').hide();
  images.find(`[data-color="${value}"]`).show();
});

var StickyAddToCart = document.getElementById('StickyAddToCart');
if (StickyAddToCart) {
  StickyAddToCart.addEventListener('click', function() {
    const section = this.closest('.shopify-section') || document;
    const info = section.querySelector('.product__info');
    if (!info) return;
    if (getComputedStyle(info).display !== 'contents') {
      info.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    const target = info.querySelector('product-variants') ||
      info.querySelector('.product-form__buy-buttons:not([hidden])') ||
      info.querySelector('.product-meta');
    if (!target) return;
    let headerBottom = 0;
    document.querySelectorAll('.shopify-section--header, .shopify-section--announcement-bar').forEach(element => {
      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) headerBottom = Math.max(headerBottom, rect.bottom);
    });
    window.scrollTo({
      top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerBottom - 16),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });
}

var xsuit4LearnMore = document.getElementById('lp-xsuit4__learn-more');
if (xsuit4LearnMore) {
  xsuit4LearnMore.addEventListener('click', function() {
    document.querySelector('.presell-grid2').scrollIntoView({ behavior: 'smooth' });
  });
}

document.querySelectorAll('.lp-xbriefcase-button').forEach(e => {
  e.addEventListener('click', function() {
    document.querySelector('.lp-xbriefcase-register__card').scrollIntoView({ behavior: 'smooth' });
  });
});

document.querySelector('form#footer-newsletter').addEventListener('submit', function(event) {
  event.preventDefault();
  const email = this.querySelector('input[name="contact[email]"]').value;
  const listId = this.querySelector('input[name="list_id"]').value;
  Promise.resolve(subscribe(email, 'footer', listId)).then((res) => {
    if (res.ok)
      this.querySelector('.banner--success').style.display = 'flex';
    else
      this.querySelector('.banner--error').style.display = 'flex';
  });
});

document.querySelectorAll('form[name="product-notify"]').forEach((form) => {
  form.addEventListener('submit', function(event) {
    event.preventDefault();
    const submitButton = this.querySelector('button[type="submit"]');
    submitButton.setAttribute("disabled", "disabled");
    submitButton.setAttribute("aria-busy", "true");
    const email = this.querySelector('input[name="email"]').value;
    const listId = this.querySelector('[name="list_id"]').value;
    var promises = [];
    document.querySelectorAll('.shopify-product-form input[name="id"][disabled]').forEach(item => {
      console.log(item.value)
      promises.push(backInStock(email, item.value, listId));
    });
    const newsletterList = document.querySelector('#footer-newsletter input[name="list_id"]');
    if (newsletterList) {
      promises.push(subscribe(email, 'back in stock', newsletterList.value));
    }
    Promise.all(promises).then((response) => {
      console.log(response);
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
      document.getElementById('product-notify-drawer').open = false;
      document.getElementById('product-notify-popover').open = false;
    }).catch(error => {
      console.log(error);
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
      document.getElementById('product-notify-drawer').open = false;
      document.getElementById('product-notify-popover').open = false;
    });
  });
});

function backInStock(email, variantId, listId) {
  return $.ajax({
    type: "POST",
    crossDomain: true,
    data: {
      a: 'MCejU3',
      email: email,
      variant: variantId,
      platform: "shopify",
    },
    url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
  });
}


function subscribe(email, source, list_id = 'WrxMcb') {
  const options = {
    method: 'POST',
    headers: {revision: '2024-10-15', 'content-type': 'application/vnd.api+json'},
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: list_id
            }
          }
        }
      }
    })
  };
  return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=MCejU3', options);
}

// async function backInStock(email, variantId, listId) {
//   const data = {
//     a: 'MCejU3',
//     email: email,
//     variant: variantId,
//     platform: "shopify",
//   };
//   const options = {
//     method: 'POST',
//     mode: 'cors',
//     headers: {revision: '2023-01-24', 'content-type': 'application/json'},
//     body: JSON.stringify(data),
//   }
//   const response = await fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', options);
//   console.log(response);
// }

// function subscribe(email, source, list_id = 'WrxMcb') {
//   const options = {
//     method: 'POST',
//     headers: {revision: '2023-01-24', 'content-type': 'application/json'},
//     body: JSON.stringify({
//       data: {
//         type: 'subscription',
//         attributes: {
//           list_id,
//           custom_source: source,
//           email: email
//         }
//       }
//     })
//   };
//   return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=MCejU3', options);
// }

// ========== SIZE CHART ==========

// Drag to scroll
var currentEle = null;
var pos = { top: 0, left: 0, x: 0, y: 0 };

var mouseDownHandler = function(e) {
    currentEle = e.target.closest('.size-guide__table-container');
    if (!currentEle) return;
    currentEle.style.cursor = 'grabbing';
    pos = {
        left: currentEle.scrollLeft,
        top: currentEle.scrollTop,
        x: e.clientX,
        y: e.clientY,
    };
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
};

var mouseMoveHandler = function(e) {
    if (!currentEle) return;
    const dx = e.clientX - pos.x;
    const dy = e.clientY - pos.y;
    currentEle.scrollTop = pos.top - dy;
    currentEle.scrollLeft = pos.left - dx;
};

var mouseUpHandler = function() {
    if (currentEle) {
        currentEle.style.cursor = 'grab';
    }
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);
};

// Keep the right-edge hint in sync with scrolling, chart visibility and resizing.
(function() {
    var charts = new Map();
    function initChartScrollFeedback() {
        document.querySelectorAll('.size-guide__table-container').forEach(function(item) {
            if (charts.has(item)) return;
            function update() {
                item.classList.toggle('mf-can-scroll-right',
                    item.clientWidth > 0 && item.scrollWidth - item.clientWidth - item.scrollLeft > 1);
            }
            var observer = new ResizeObserver(update);
            observer.observe(item);
            var content = item.querySelector('.size-guide__table-scroll');
            if (content) observer.observe(content);
            item.addEventListener('mousedown', mouseDownHandler);
            item.addEventListener('scroll', update, { passive: true });
            charts.set(item, { observer: observer, update: update });
            update();
        });
    }
    document.addEventListener('shopify:section:unload', function(event) {
        charts.forEach(function(state, item) {
            if (!item.isConnected || event.target.contains(item)) {
                state.observer.disconnect();
                item.removeEventListener('mousedown', mouseDownHandler);
                item.removeEventListener('scroll', state.update);
                charts.delete(item);
            }
        });
    });
    document.addEventListener('shopify:section:load', initChartScrollFeedback);
    initChartScrollFeedback();
})();

// Store original CM values
var sizeChartOriginalValues = [];

function initSizeChart() {
    sizeChartOriginalValues = [];
    $('.SIZE_CHART_POPUP-CONTAINER tr:not(:first-child) > td').each(function(index) {
        var cell = $(this).find('div');
        sizeChartOriginalValues[index] = cell.text();
    });
}

// Restore original CM values
function toCM() {
    $('.SIZE_CHART_POPUP-CONTAINER tr:not(:first-child) > td').each(function(index) {
        if (sizeChartOriginalValues[index]) {
            var cell = $(this).find('div');
            cell.text(sizeChartOriginalValues[index]);
        }
    });
}

// Convert CM to INCH
function toINCH() {
    $('.SIZE_CHART_POPUP-CONTAINER tr:not(:first-child) > td').each(function(index) {
        var originalText = sizeChartOriginalValues[index];
        if (!originalText) return;
        
        var cell = $(this).find('div');
        var text = originalText.trim();
        
        // Check if it contains a range with " - "
        if (text.indexOf(' - ') !== -1) {
            var parts = text.split(' - ');
            var converted = parts.map(function(part) {
                var num = parseFloat(part.trim());
                if (!isNaN(num)) {
                    return Math.round(num / 2.54 * 10) / 10;
                }
                return part;
            });
            cell.text(converted.join(' - '));
        } else {
            var num = parseFloat(text);
            if (!isNaN(num) && text.match(/^[\d.]+$/)) {
                cell.text(Math.round(num / 2.54 * 10) / 10);
            }
        }
    });
}

// Toggle click handler
$('.SIZE_CHART_POPUP-CONTAINER .SIZE_GUIDE_PAGE-JACKET-HEADER-OPTIONS-SELECTOR-WRAP').click(function() {
    var toggle = $('.SIZE_CHART_POPUP-CONTAINER .size-guide__toggle');
    if (toggle.hasClass('active')) {
        toggle.removeClass('active');
        toCM();
    } else {
        toggle.addClass('active');
        toINCH();
    }
});

// Size length selector (if exists)
$('.size-length__cell').off('click').click(function() {
    $(this).siblings().removeClass('selected');
    $(this).addClass('selected');
    $(this).parents('.SIZE_GUIDE_PAGE').attr('data-state', $(this).find('.size-length__text').text());
});

// Initialize on document ready
$(document).ready(function() {
    setTimeout(initSizeChart, 200);
});

// function updatePromoVisibility(cart) {
//   const hasTie = cart.items.some(item => item.handle.includes('xtie-2-0'));
//   const hasSquare = cart.items.some(item => item.handle.includes('xsquare'));
//   const hasJacket = cart.items.some(item => item.handle.includes('infinity-suit-jacket'));
//   const hasPant = cart.items.some(item => item.handle.includes('infinity-dress-pant'));
//   const hasSuit = hasJacket && hasPant;

//   const tiePromo = document.getElementById('mini-cart__promo-tie');
//   const squarePromo = document.getElementById('mini-cart__promo-square');

//   if (tiePromo) {
//     tiePromo.style.display = (hasSuit && !hasTie) ? '' : 'none';
//   }
//   if (squarePromo) {
//     squarePromo.style.display = (hasSuit && !hasSquare) ? '' : 'none';
//   }
// }

// document.documentElement.addEventListener('cart:refresh', (event) => {
//   const miniCart = document.getElementById('mini-cart');
  
//   if (miniCart && event.detail.cart) {
//     const observer = new MutationObserver(() => {
//       updatePromoVisibility(event.detail.cart);
//       observer.disconnect();
//     });
    
//     observer.observe(miniCart, { childList: true, subtree: true });
//     setTimeout(() => observer.disconnect(), 2000);
//   }
// });

// document.addEventListener('DOMContentLoaded', () => {
//   fetch(`${window.themeVariables.routes.cartUrl}.js`)
//     .then(response => response.json())
//     .then(cart => {
//       updatePromoVisibility(cart);
//     });
// });

$(document).on('change', 'product-variants[form-id^="promo-form-"] select[name^="option"]', function() {
  const $pv = $(this).closest('product-variants');
  const handle = $pv.attr('handle');
  const $script = $(`script[data-promo-variants="${handle}"]`);
  if (!$script.length) return;

  const variants = JSON.parse($script.text());
  const options = {};
  $pv.find('select[name^="option"]').each(function() {
    const pos = parseInt($(this).attr('name').replace('option', ''));
    options[pos] = $(this).val();
  });

  const matched = variants.find(v =>
    (!options[1] || v.option1 === options[1]) &&
    (!options[2] || v.option2 === options[2]) &&
    (!options[3] || v.option3 === options[3])
  );

  if (matched) {
    $pv.closest('form').find('input[data-promo-input]').val(matched.id);
  }
});

(() => {
  const root = document.documentElement;
  const drawerSelector = '#mini-cart, #mobile-menu-drawer, .drawer--size-chart, .popover--size-chart';
  const getDrawers = () => Array.from(document.querySelectorAll(drawerSelector));
  let updateFrame = 0;
  let headerObserver;

  const updatePosition = () => {
    const bottom = Array.from(document.querySelectorAll('.shopify-section--header, .shopify-section--announcement-bar'))
      .reduce((value, element) => {
        const rect = element.getBoundingClientRect();
        if (rect.height === 0 || rect.bottom <= 0 || rect.top >= window.innerHeight) return value;
        return Math.max(value, rect.bottom);
      }, 0);
    const top = Math.ceil(Math.min(bottom, window.innerHeight));
    const value = top + 'px';
    if (root.style.getPropertyValue('--mf-header-drawer-top') !== value) {
      root.style.setProperty('--mf-header-drawer-top', value);
    }
    root.classList.toggle('mf-header-drawer-open', getDrawers().some(drawer => drawer.hasAttribute('open')));
  };

  const scheduleUpdate = () => {
    if (updateFrame) return;
    updateFrame = requestAnimationFrame(() => {
      updateFrame = 0;
      updatePosition();
    });
  };

  const closeDrawer = drawer => {
    if (!drawer?.hasAttribute('open')) return;
    drawer.focusTrap.deactivate({ returnFocus: false });
    drawer.open = false;
  };

  document.addEventListener('openable-element:open', event => {
    if (!(event.target instanceof Element) || !event.target.matches(drawerSelector)) return;
    getDrawers().filter(drawer => drawer !== event.target).forEach(closeDrawer);
    updatePosition();
    scheduleUpdate();
  });

  document.addEventListener('openable-element:close', event => {
    if (event.target instanceof Element && event.target.matches(drawerSelector)) scheduleUpdate();
  });

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest('.shopify-section--header, .shopify-section--announcement-bar')) return;
    const control = target.closest('[aria-controls]');
    const targetId = control?.getAttribute('aria-controls');
    getDrawers().filter(drawer => drawer.id !== targetId).forEach(closeDrawer);
    updatePosition();
  }, true);

  document.addEventListener('desktop-nav:dropdown:open', () => {
    getDrawers().filter(drawer => drawer.id !== 'mobile-menu-drawer').forEach(closeDrawer);
    scheduleUpdate();
  });

  document.addEventListener('pointerover', event => {
    const target = event.target instanceof Element ? event.target : null;
    const item = target?.closest('.shopify-section--header .header__linklist-item');
    if (!item?.querySelector('.header-submenu')) return;
    if (event.relatedTarget instanceof Node && item.contains(event.relatedTarget)) return;
    getDrawers().filter(drawer => drawer.id !== 'mobile-menu-drawer').forEach(closeDrawer);
    scheduleUpdate();
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    getDrawers().forEach(drawer => {
      if (drawer?.hasAttribute('open')) drawer.open = false;
    });
    scheduleUpdate();
  });

  const observeHeader = () => {
    headerObserver?.disconnect();
    if (window.ResizeObserver) {
      headerObserver = new ResizeObserver(scheduleUpdate);
      document.querySelectorAll('.shopify-section--header, .shopify-section--announcement-bar')
        .forEach(element => headerObserver.observe(element));
    }
    updatePosition();
  };

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.visualViewport?.addEventListener('resize', scheduleUpdate, { passive: true });
  document.addEventListener('shopify:section:load', observeHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeHeader, { once: true });
  else observeHeader();
})();



// Mobile product galleries: coast freely, then align to the nearest photo.
(() => {
  const selector = '.product__media flickity-carousel.product__media-list';
  const phone = window.matchMedia('(max-width: 740px)');
  const attached = new WeakMap();

  const attach = async carousel => {
    const instance = await carousel.flickityInstance;
    if (!instance || !carousel.isConnected || attached.get(carousel)?.instance === instance) return;
    const original = {
      freeScroll: instance.options.freeScroll,
      freeScrollFriction: instance.options.freeScrollFriction,
      wrapAround: instance.options.wrapAround,
      contain: instance.options.contain
    };
    const state = { instance, needsSnap: false };
    attached.set(carousel, state);
    const configure = () => {
      state.needsSnap = false;
      delete instance.isFreeScrolling;
      Object.assign(instance.options, phone.matches ? {
        freeScroll: true,
        freeScrollFriction: 0.075,
        wrapAround: false,
        contain: false
      } : original);
      instance.resize();
    };
    const onDragStart = () => { state.needsSnap = phone.matches; };
    const onSettle = () => {
      if (!phone.matches || !state.needsSnap || !instance.slides.length) return;
      state.needsSnap = false;
      let nearest = instance.selectedIndex;
      let distance = Math.abs(instance.x + instance.slides[nearest].target);
      instance.slides.forEach((slide, index) => {
        const nextDistance = Math.abs(instance.x + slide.target);
        if (nextDistance < distance) { nearest = index; distance = nextDistance; }
      });
      // Flickity clears free-scrolling on settle; the next selection aligns smoothly.
      if (distance > 0.5 || nearest !== instance.selectedIndex) instance.select(nearest);
    };
    const onDestroy = () => {
      phone.removeEventListener('change', configure);
      instance.off('dragStart', onDragStart);
      instance.off('settle', onSettle);
      instance.off('destroy', onDestroy);
      if (attached.get(carousel) === state) attached.delete(carousel);
    };
    instance.on('dragStart', onDragStart);
    instance.on('settle', onSettle);
    instance.on('destroy', onDestroy);
    phone.addEventListener('change', configure);
    configure();
  };
  const scan = root => root.querySelectorAll(selector).forEach(attach);
  document.addEventListener('flickity:ready', event => {
    if (event.target instanceof Element && event.target.matches(selector)) attach(event.target);
  });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
})();

// Match the desktop option feedback while keeping native mobile scrolling/selection.
(function mfMobileSizeOptionFeedback() {
  const mobile = window.matchMedia('(max-width: 740px)');
  const optionSelector = '.product-form__option-selector[data-selector-type="dropdown"] .combo-box__option-item';
  let press = null;

  function clearPress() {
    if (!press) return;
    press.option.classList.remove('is-mf-option-pressed');
    press = null;
  }

  document.addEventListener('pointerdown', function(event) {
    clearPress();
    if (!mobile.matches || !event.isPrimary || event.button !== 0) return;
    const option = event.target.closest(optionSelector);
    if (!option || option.disabled || option.classList.contains('is-disabled') || option.getAttribute('aria-disabled') === 'true') return;
    press = { option: option, id: event.pointerId, x: event.clientX, y: event.clientY };
    option.classList.add('is-mf-option-pressed');
  }, { passive: true });

  document.addEventListener('pointermove', function(event) {
    if (!press || event.pointerId !== press.id) return;
    if (Math.hypot(event.clientX - press.x, event.clientY - press.y) > 8) clearPress();
  }, { passive: true });

  function endPress(event) {
    if (press && event.pointerId === press.id) clearPress();
  }
  document.addEventListener('pointerup', endPress, { passive: true });
  document.addEventListener('pointercancel', endPress, { passive: true });
  document.addEventListener('scroll', function(event) {
    if (press && event.target.contains && event.target.contains(press.option)) clearPress();
  }, { capture: true, passive: true });
  window.addEventListener('blur', clearPress);
  mobile.addEventListener('change', clearPress);
})();



/* Keep mobile headers fixed only while the Gorgias window is open. */
(function mfMobileChatHeaderState() {
  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 740px)');
  const className = 'mf-mobile-chat-open';
  const loaded = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(resolve => window.addEventListener('gorgias-widget-loaded', resolve, { once: true }));

  Promise.resolve(loaded).then(() => {
    const chat = window.GorgiasChat;
    if (!chat) return;
    const sync = () => root.classList.toggle(className, mobile.matches && chat.isOpen());
    chat.on('widget:opened', () => root.classList.toggle(className, mobile.matches));
    chat.on('widget:closed', () => root.classList.remove(className));
    chat.on('destroy', () => root.classList.remove(className));
    mobile.addEventListener('change', sync);
    window.addEventListener('pageshow', sync);
    sync();
  }).catch(() => root.classList.remove(className));
})();
